import * as $ from 'jquery';

document.addEventListener('DOMContentLoaded', () => {
	const $item = $('.channelAddons');
	const selector = '.details__heading';

	if (!$item.length) {
		return;
	}

	function toggleControlledItems(element: Element): void {
		const $element = $(element);
		//*DEBUG*/ console.log(element);
		$element.attr('aria-expanded', function(index, attr){
			return attr == 'true' ? 'false' : 'true';
		});
		$element.attr('aria-controls').split(' ').forEach(id => {
			if (id.lastIndexOf('media-') === 0){
				//*DEBUG*/ console.log(document.getElementById(id));
				document.getElementById(id).classList.toggle('active');
			}
		});
	}

	function toggleItem(element: Element, force?: boolean): void {
		//*DEBUG*/ console.log(element);
		const $element = $(element);
		const isOpen = $element.parent().hasClass('expanded');

		if (isOpen) {
			return;
		} else {
			const $oldElement = $element.parent().siblings().filter('.expanded');
			if ($oldElement.length > 0){
				$oldElement.removeClass('expanded');
				toggleControlledItems($oldElement.find(selector).get(0));
			}
			$element.parent().addClass('expanded');
			toggleControlledItems($element.get(0));
		}
	}

	function toggleItemFirst(): void {
		let element = document.querySelector(selector);
		toggleItem(element);
	}
	// function toggleItemTargeted(): void {
	// 	let id = (window.location.hash).replace(/([\.\:])/, '\\$1');
	// 	const $targetedElement = $item.find(id);
	// selector - remove .
	// 	if ($targetedElement.hasClass(className)) {
	// 		toggleItem($targetedElement.get(0));
	// 	}
	// }

	function setupEventHandlers(): void {
		$item.on('click', selector, (event) => {
			event.preventDefault();
			history.replaceState(undefined, undefined, location.pathname + "#" + event.currentTarget.id);
			toggleItem(event.currentTarget);
		});
	}

	setupEventHandlers();
	$item.addClass('js-ready');

	const goo = () => {
		$item.find(selector).attr('aria-expanded', 'false');
	};
	$.when(goo()).done(() => {
		// toggleItemTargeted();
		toggleItemFirst();
	});
});